/**
 * v2 네비 트리 유틸 (FIKET-417 권한 필터 · FIKET-428 2단계 메뉴)
 *
 * useVisibleNav / SideNav 가 쓰는 순수 함수. React 의존 없음 → 단위 테스트 대상.
 */
import type { V2NavGroup, V2NavItem } from './nav-config'

/** pathname 이 `to` 자체이거나 그 하위 세그먼트인지 (prefix 문자열 일치가 아닌 세그먼트 경계 기준) */
export function isPathUnder(pathname: string, to: string): boolean {
  return pathname === to || pathname.startsWith(to + '/')
}

/**
 * 권한 필터 — 볼 수 없는 항목·빈 그룹 제거.
 * children 이 있는 부모는 자식 기준으로 판정한다(볼 수 있는 자식이 하나도 없으면 부모도 제거).
 */
export function filterNavGroups(groups: V2NavGroup[], canViewPath: (pathname: string) => boolean): V2NavGroup[] {
  return groups
    .map((g) => ({
      ...g,
      items: g.items.flatMap((item): V2NavItem[] => {
        if (item.children) {
          const children = item.children.filter((c) => canViewPath(c.to))
          return children.length > 0 ? [{ ...item, children }] : []
        }
        return canViewPath(item.to) ? [item] : []
      }),
    }))
    .filter((g) => g.items.length > 0)
}

/**
 * 실제 페이지(리프)만 평탄화 — 탑바 검색·홈 바로가기용.
 * 2단계 자식은 "부모 자식"(예: "챗봇 FAQ")으로 라벨을 합성해 부모 이름으로도 검색되게 한다. 부모 자체는 라우트가 아니라 제외.
 */
export function flattenNavLeaves(groups: V2NavGroup[]): V2NavItem[] {
  return groups.flatMap((g) =>
    g.items.flatMap((item): V2NavItem[] => {
      if (item.children) {
        return item.children.map((c) => ({ ...c, label: `${item.label} ${c.label}` }))
      }
      return [item]
    }),
  )
}
